import { useEffect } from 'react';
import { AppState, Platform } from 'react-native';
import { useAuthStore } from '@/store/auth';
import { hasAiSharingConsent, useAiSharingConsent } from '@/store/aiSharingConsent';
import { optionalMobileNativeModule, optionalNativeEvent } from '@/lib/mobileNativeCapabilities';
import { fetchWithAuth } from '@/lib/api/client';
import { nativeLinkInbox } from '@/lib/nativeLinkInbox';
import { createWatchCoordinator } from '@/lib/watchCompanion';

export default function WatchCompanionHost() {
  useEffect(() => {
    if (Platform.OS !== 'ios') return;
    const native = optionalMobileNativeModule('WatchCompanion', ['status', 'configure', 'clear', 'consumeConversation']);
    if (!native) return;
    const coordinator = createWatchCoordinator({ native,
      issue: installationId => fetchWithAuth('/json/watch/sessions', { method: 'POST', body: { installationId, consentVersion: 1 } }),
      revoke: token => fetch('https://gab.ai/json/watch/session', { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } }),
      capture: path => nativeLinkInbox.capture(path),
    });
    const update = () => {
      const auth = useAuthStore.getState();
      return coordinator.update({ accountId: auth.user?.id,
        hydrated: auth._hasHydrated,
        allowed: !!auth.token && !auth._isSigningOut && hasAiSharingConsent(auth.user?.id),
      }).catch(() => {});
    };
    const authSubscription = useAuthStore.subscribe(update), consentSubscription = useAiSharingConsent.subscribe(update);
    const connect = optionalNativeEvent(native, 'watchConnect', () => { void coordinator.synchronize({ force: true }).catch(() => {}); });
    const open = optionalNativeEvent(native, 'watchOpenConversation', () => { void coordinator.open().catch(() => {}); });
    const foreground = AppState.addEventListener('change', state => { if (state === 'active') { void update(); void coordinator.open().catch(() => {}); } });
    void update();
    return () => { coordinator.dispose(); authSubscription(); consentSubscription(); connect?.remove(); open?.remove(); foreground.remove(); };
  }, []);
  return null;
}
